import React, { useEffect, useState } from "react";
import { Box, Button, HStack, Text, VStack, Pressable } from "native-base";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { showToast } from "@helpers/toast";
import AntdModal from "@views/components/ui/antd_modal";

import { AiOutlineEdit, AiOutlineDelete } from "react-icons/ai";
import Wrapper from "@views/components/ui/wrapper";
import { Pagination, Popconfirm, Table, Typography } from "antd";
import { useHistory } from "react-router-dom";
import {
  delete_infographic_note,
  delete_infographic_topic,
  dynamicClear,
  dynamicRequest,
  get_all_infographic_notes,
  useDynamicSelector,
} from "@services/redux";
import InfographicNotesDetails from "./infographic_notes_details";
import { ROUTES } from "@views/routes/my_routes";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

const InfographicNotesList = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();
  const [actionItem, setActionItem] = useState({});

  const [current, setCurrent] = useState(1);
  const [current_limit, setCurrentLimit] = useState(10);
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);
  const [actionType, setActionType] = useState(null);

  const {
    items: infographic_topics,
    pagination,
    loading,
  } = useDynamicSelector("getInfographicNotes");
  const { status: create_status, error: create_error } = useDynamicSelector(
    "createInfographicNote"
  );
  const { status: update_status, error: update_error } = useDynamicSelector(
    "updateInfographicNote"
  );
  const {
    loading: delete_loading,
    status: delete_status,
    error: delete_error,
  } = useDynamicSelector("deleteInfographicNote");
  const handleAdd = () => {
    setActionItem({});
    setActionType("add");
    setModalOpen(true);
  };

  const handleEdit = (item) => {
    setActionItem(item);
    setActionType("edit");
    setModalOpen(true);
  };
  const handleModalClose = () => {
    setModalOpen(false);
  };

  const handleGetInfographicNotes = () => {
    let keys = [{ key: "getInfographicNotes", loading: true }];
    let query = get_all_infographic_notes;
    let variables = {
      json: {
        page_number: current,
        page_limit: current_limit,
        infographic_topic_id: id,
      },
    };
    dispatch(dynamicRequest(keys, query, variables));
  };

  const fetchData = (page_number, page_limit) => {
    let keys = [{ key: "getInfographicNotes", loading: true }];
    let query = get_all_infographic_notes;
    let variables = {
      json: { page_number, page_limit, infographic_topic_id: id },
    };
    dispatch(dynamicRequest(keys, query, variables));
    setCurrent(page_number);
    setCurrentLimit(page_limit);
  };

  const handleDelete = (record) => {
    let keys = [{ key: "deleteInfographicNote", loading: true }];
    dispatch(
      dynamicRequest(keys, delete_infographic_note, {
        json: { id: record?.id },
      })
    );
  };

  useEffect(() => {
    handleGetInfographicNotes();
  }, []);

  useEffect(() => {
    if (create_error) {
      showToast({
        type: "error",
        message: "Something went wrong",
      });
      dispatch(dynamicClear("createInfographicNote"));
    } else if (create_status === "success") {
      showToast({
        type: "success",
        message: "Infographic note created successfully",
      });
      handleModalClose();
      handleGetInfographicNotes();
      dispatch(dynamicClear("createInfographicNote"));
    } else if (update_error) {
      showToast({
        type: "error",
        message: "Something went wrong",
      });
      dispatch(dynamicClear("updateInfographicNote"));
    } else if (update_status === "success") {
      showToast({
        type: "success",
        message: "Infographic note updated successfully",
      });
      handleModalClose();
      handleGetInfographicNotes();
      dispatch(dynamicClear("updateInfographicNote"));
    }
  }, [create_error, create_status, update_error, update_error]);

  useEffect(() => {
    if (delete_error) {
      showToast({
        type: "error",
        message: "Something went wrong",
      });
      dispatch(dynamicClear("deleteInfographicNote"));
    } else if (delete_status === "success") {
      showToast({
        type: "success",
        message: "Infographic note deleted successfully",
      });
      handleModalClose();
      handleGetInfographicNotes();
      dispatch(dynamicClear("deleteInfographicNote"));
    }
  }, [delete_error, delete_status]);
  let columns = [
    {
      title: t("table:name"),
      dataIndex: "name",
      key: "name",
      sortable: false,
      align: "left",
      flex: 1,
    },
    {
      title: t("table:sort_order"),
      dataIndex: "sort_order",
      key: "sort_order",
      sortable: false,
      align: "left",
      width: 200,
    },
    {
      title: t("table:actions"),
      dataIndex: "",
      key: "actions",
      type: "actions",
      align: "center",
      render: (record) => {
        return (
          <span>
            <Typography.Link
              onClick={() => handleEdit(record)}
              style={{ marginRight: 15 }}
            >
              <AiOutlineEdit />
              {/* <Text color="blue.400">Edit</Text> */}
            </Typography.Link>
            <Popconfirm
              title="Sure to delete?"
              onConfirm={() => handleDelete(record)}
            >
              <AiOutlineDelete />
              {/* <Text color="red.400">
                  <a>Delete</a>
                </Text> */}
            </Popconfirm>
          </span>
        );
      },
    },
  ];

  return (
    <>
      <Box position="sticky" top="10px" zIndex="2" bg="white">
        <Text fontSize="md" fontWeight="bold">
          {t("infographic_note")}
        </Text>
      </Box>
      <Box width="100%" mt="10px" marginBottom="20px">
        <VStack space={5}>
          <HStack space={3} justifyContent="flex-end" m={3}>
            <Box key={`header-action`}>
              <Button type="primary" onPress={handleAdd}>
                {t("add_infographic_note")}
              </Button>
            </Box>
          </HStack>
          <Wrapper>
            <Table
              loading={loading}
              columns={columns}
              dataSource={infographic_topics}
              pagination={false}
            />
          </Wrapper>
          <Pagination
            total={pagination?.total_count}
            showSizeChanger={true}
            current={current}
            hideOnSinglePage={false}
            onChange={fetchData}
          />
        </VStack>
      </Box>
      <AntdModal
        isOpen={modalOpen}
        onClose={handleModalClose}
        width={450}
        header={
          actionType === "add"
            ? t("add_infographic_note")
            : t("edit_infographic_note")
        }
        component={
          <InfographicNotesDetails
            topic_id={id}
            label={"add"}
            close={handleModalClose}
            initialValues={actionItem}
          />
        }
      />
    </>
  );
};
export default InfographicNotesList;
